import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import Joi from "react-native-joi";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayout";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [failed, setFailed] = useState(false);
  const [failedMessage, setFailedMessage] = useState("");
  useEffect(() => {
    if (props.route.params && props.route.params.userInfo.nombre) {
      setNombre(props.route.params.userInfo.nombre);
      setApellido(props.route.params.userInfo.apellido);
      setEmail(props.route.params.userInfo.email);
      setTelefono(props.route.params.userInfo.telefono);
    }
  }, []);
  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>

      <View>
        <Title>Modificar datos</Title>
        <InputLayout
          placeholder='Nombre'
          value={nombre}
          onChangeText={setNombre}
          schema={Joi.string()
            .min(3)
            .max(150)
            .regex(/[A-z]./)
            .required()}
          errorMessage='Inserte un nombre válido'
        />
        <InputLayout
          placeholder='Apellido'
          value={apellido}
          onChangeText={setApellido}
          schema={Joi.string()
            .min(3)
            .max(150)
            .regex(/[A-z]./)
            .required()}
          errorMessage='Inserte un apellido válido'
        />
        <InputLayout
          placeholder='Correo electrónico'
          schema={Joi.string()
            .regex(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)
            .min(1)
            .max(255)
            .required()}
          errorMessage='Inserte un correo válido'
          value={email}
          onChangeText={setEmail}
        />
        <InputLayout
          placeholder='Teléfono móvil'
          schema={Joi.string()
            .regex(/^(6|7)[0-9]{8}$/)
            .max(9)
            .required()}
          errorMessage='Inserte un teléfono válido'
          value={telefono}
          keyboardType='number-pad'
          onChangeText={setTelefono}
        />
        {failed && (
          <Title style={{ fontSize: 15, color: "red" }}>{failedMessage}</Title>
        )}
        <ButtonLayout
          text='Modificar datos'
          onPress={async () => {
            const response = await makeRequest("users", "put", {
              nombre: nombre,
              apellido: apellido,
              email: email,
              telefono: telefono,
            });
            if (response[0] == 200)
              props.navigation.navigate(props.route.params.previous, {
                userInfo: {
                  nombre: nombre,
                  apellido: apellido,
                  email: email,
                  telefono: telefono,
                  id: props.route.params.userInfo.id,
                },
              });
            else {
              setFailed(true);
              setFailedMessage("Introduzca valores válidos");
            }
          }}></ButtonLayout>
        <ButtonLayoutMenu
          text='Cancelar'
          style={{ maxWidth: 150, alignSelf: "center" }}
          onPress={() => props.navigation.popToTop()}></ButtonLayoutMenu>
        <TouchableOpacity
          onPress={() =>
            props.navigation.navigate("CambiarContrasena", props.route.params)
          }>
          <Title>Cambiar contraseña</Title>
        </TouchableOpacity>
        <View style={{ height: 50 }}></View>
      </View>
    </BackgroundUser>
  );
}
